import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProjectsRoutingModule } from './projects-routing.module';

// Google Maps Module
import { GoogleMapsModule } from '@angular/google-maps';

// PrimeNG Modules
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { DialogModule } from 'primeng/dialog';
import { RippleModule } from 'primeng/ripple';
import { MenuModule } from 'primeng/menu';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ChartModule } from 'primeng/chart';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';

// Components
import { ProjectsListComponent } from './projects-list/projects-list.component';
import { ProjectCreateDialogComponent } from './project-create-dialog/project-create-dialog.component';
import { ProjectAnalyticsComponent } from './project-analytics/project-analytics.component';

// Shared Module
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    ProjectsListComponent,
    ProjectCreateDialogComponent,
    ProjectAnalyticsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ProjectsRoutingModule,
    GoogleMapsModule,
    CardModule,
    ButtonModule,
    InputTextModule,
    InputTextareaModule,
    ProgressSpinnerModule,
    ToastModule,
    ConfirmPopupModule,
    DynamicDialogModule,
    DialogModule,
    RippleModule,
    MenuModule,
    SplitButtonModule,
    ChartModule,
    SkeletonModule,
    TableModule,
    SharedModule
  ],
  exports: [
    ProjectsListComponent,
    ProjectAnalyticsComponent
  ]
})
export class ProjectsModule { }